export const interleave = <K, T extends any>(
  arr: T[],
  thing: K,
  mutateFn?: (thing: K, index: number) => K,
): (T | K)[] =>
  []
    .concat(
      ...arr.map((n, index) => [n, mutateFn ? mutateFn(thing, index) : thing]),
    )
    .slice(0, -1);

export function interleaveNext<T>(
  array: T[],
  callback: (index: number) => T,
): T[] {
  const result: T[] = [];

  for (let i = 0; i < array.length; i++) {
    result.push(array[i]);
    if (callback(i) && i < array.length - 1) {
      result.push(callback(i));
    }
  }

  return result;
}